import { render, staticRenderFns } from "./TxRowMobile.vue?vue&type=template&id=7ef525f8"
import script from "./TxRowMobile.vue?vue&type=script&lang=js"
export * from "./TxRowMobile.vue?vue&type=script&lang=js"
import style0 from "./TxRowMobile.vue?vue&type=style&index=0&id=7ef525f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports